import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, catchError, map, Observable, of, switchMap, tap } from "rxjs";
import { environment } from "src/environments/environment";
// @ts-ignore
import { Md5 } from "ts-md5";
import { ApplicationService } from "./application.service";
import { LoggedUser } from "./models/logged-user";
import { MeUser } from "./models/me-user";
import { MyUtils } from "./my-utils.service";
import { IPayload } from "../interface/filters";
import { UpdateTimestamp } from "../modules/pages/analysis/overview/overview.component";
import { LoaderService } from "./loader.service";
import { JwtHelperService } from "@auth0/angular-jwt";


@Injectable({
  providedIn: "root",
})
export class AuthService {
  public isRememberMeChecked: boolean = false;
  private tokenSubject: BehaviorSubject<string>;
  public token$: Observable<string>;
  isSSO = false;

  public meSelectSubject = new BehaviorSubject<MeUser | null>(null);
  public me$: Observable<MeUser | null>;

  private emailSbj: BehaviorSubject<string>;

  constructor(
    private utils: MyUtils,
    private applicationService: ApplicationService,
    private http: HttpClient,
    private loader: LoaderService
  ) {
    const storedToken = localStorage.getItem("token");
    this.tokenSubject = new BehaviorSubject<string>(storedToken ? JSON.parse(storedToken) : "");
    this.token$ = this.tokenSubject.asObservable();

    this.me$ = this.meSelectSubject.asObservable();/*.pipe(
      switchMap(me => me ? of(me) : this.me())
    );*/

    // this.me().subscribe((user) => {

    // });

    this.emailSbj = new BehaviorSubject<string>(localStorage.getItem("email") || "");
  }

  private setTokenValue(token: string) {
    localStorage.setItem("token", JSON.stringify(token));
    this.tokenSubject.next(token);
  }
  public get tokenSelectValue() {
    return typeof this.tokenSubject.value === 'string' ? this.tokenSubject.value : '';
  }

  private setMeValue(me: MeUser) {
    localStorage.setItem("me", JSON.stringify(me));
    this.meSelectSubject.next(me);
  }
  public get meSelectValue() {
    return this.meSelectSubject.value;
  }

  public get meSelectUpdatedValue() {
    if (this.meSelectSubject.value == null) {
      const me = JSON.parse(localStorage.getItem("me") ?? '') as MeUser;
      this.meSelectSubject.next(me ?? null)
    }
    return this.meSelectSubject.value;
  }

  // ONLY FOR DEV ACTUALLY! For the authentication use the ssoHarmonization method
  login(userGroup: { username: string; password: string; isRememberMeChecked: boolean }) {
    let header = this.crypto(userGroup.password, userGroup.username);
    let url = environment.csibefrontend + `v2/login`;

    if (environment.featureFlags.ssoHarmonization)
      url = environment.csibefrontend + `login/v2/login`;

    return this.http.get<LoggedUser>(url, { headers: header }).pipe(
      tap((data) => {
        if (data) {
          this.setTokenValue("");
          this.meSelectSubject.next(null);
          this.resetFilterSessionState();
          this.setTokenValue(data ? data.token : "");
          data.userProfile = this.utils.userRole(data);
          let user = {
            username: userGroup.username,
            password: userGroup.password,
            isRememberMeChecked: userGroup.isRememberMeChecked,
          };
          //this.applicationService.setLanguageValue(data.defaultLocale);
          localStorage.setItem(
            "currentUser",
            JSON.stringify(userGroup.isRememberMeChecked ? user : "")
          );
          localStorage.setItem("email", userGroup.username);
          this.emailSbj.next(userGroup.username);
        }
      }),
      catchError((err) => {
        console.error(err);
        return of(null);
      })
    );
  }

  me() {

    let endPointMe = environment.csibefrontend + `v3/me`;
    if (environment.featureFlags.ssoHarmonization) {
      endPointMe = environment.csibefrontend + `login/v2/dealer/me`;
    }
    this.loader.startLoader();
    return this.http.get<MeUser>(endPointMe).pipe(
      map((me) => {

        if (environment.featureFlags.ssoHarmonization) {
          const meOut = new MeUser(me);
          meOut.dealer = meOut.dealerInfo?.[0]?.dealerId ?? "";
          return meOut;
        }
        else {
          return new MeUser(me);
        }

      }
      ),
      tap((me) => {
        this.loader.stopLoader();
        localStorage.setItem("email", me.email);
        this.emailSbj.next(me.email);
        this.setMeValue(me);
      })
    );
  }

  sso() {
    return this.http.get<any>(environment.csibefrontend + `ssopsalogin`)
  }

  private crypto(password: string, username: string) {
    let passwordMD5 = Md5.hashStr(password);
    let authB64 = btoa(`${username}:${passwordMD5}`);
    let header = new HttpHeaders({ Authorization: `Basic ${authB64}` });
    return header;
  }

  resetsSubject() {
    this.setTokenValue("");
    this.emailSbj.next("");
    this.meSelectSubject.next(null);
    this.isRememberMeChecked = false;
    this.resetFilterSessionState();
  }

  private resetFilterSessionState(): void {
    this.applicationService.resetFilterSessionState();
    this.utils.resetSettingsPayload();
  }

  get email() {
    return this.emailSbj.value;
  }

  loginSSO(tkn: string) {
    if (tkn) {
      const decodedToken = new JwtHelperService().decodeToken(tkn);
      this.applicationService.setLanguageValue(decodedToken.defaultLocale);
      this.setTokenValue(tkn);
      this.isSSO = true;
    }
  }

  lastUpdateTimestamp(body: IPayload) {
    return this.http.post<UpdateTimestamp>(environment.csibefrontend + `survey/getProcessingDate`, body)
  }
}
